"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const SelectableSample_1 = __importDefault(require("@becrop/components/Toolkit/Heatmap2/models/SelectableSample"));
const sleep_1 = __importDefault(require("@common/tsutils/sleep"));
class SelectableSampleList {
    constructor(samples = []) {
        this.samples = [];
        this.samples = samples.map(s => new SelectableSample_1.default(s));
    }
    selectAll() {
        this.samples.forEach(s => s.selected = true);
    }
    unSelectAll() {
        console.log("Un seleted");
        this.samples.forEach(s => s.selected = false);
    }
    get numSelected() {
        return this.samples.reduce((acc, s) => acc + ((s.selected && !s.disabled) ? 1 : 0), 0);
    }
    get isAllSelected() {
        return this.numSelected === this.samples.length;
    }
    getSelectedSamples() {
        return this.samples.filter(s => s.selected).map(s => s.sample);
    }
    getNewSelectedSamples() {
        return this.samples.filter(s => s.selected && !s.disabled).map(s => s.sample);
    }
    markDisabled() {
        return this.samples.filter(s => s.selected).map(s => s.disabled = true);
    }
    add(samples) {
        samples.forEach(s => {
            const ss = new SelectableSample_1.default(s);
            this.samples.push(ss);
        });
    }
    get length() {
        return this.samples.length;
    }
    find(sample) {
        return this.samples.find(ss => {
            return ss.sample === sample;
        });
    }
    findByCode(code) {
        const sample = this.samples.find(ss => {
            return ss.sample.code === code;
        });
        if (!sample) {
            console.warn("Not found sample " + code);
            return null;
        }
        return sample;
    }
    findArray(samples) {
        return samples.map(s => this.find(s));
    }
    rm(sample) {
        const idx = this.samples.findIndex(ss => {
            return ss.sample === sample;
        });
        if (idx === -1)
            return;
        this.samples.splice(idx, 1);
    }
    async asyncFilter(filters = []) {
        const list = new SelectableSampleList();
        for (const sample of this.samples) {
            await (0, sleep_1.default)(0);
            if (!sample.sample.checkFilters(filters))
                continue;
            list.samples.push(sample);
        }
        return list;
    }
    async asyncFilterText(text) {
        const list = new SelectableSampleList();
        for (const sample of this.samples) {
            await (0, sleep_1.default)(0);
            if (!sample.sample.checkFilterText(text))
                continue;
            list.samples.push(sample);
        }
        return list;
    }
}
exports.default = SelectableSampleList;
